<template>
    <div id="app-content" style="padding-top: 20px; padding-bottom: 40px; margin: 0 auto; width: 95%;">
        <div class="alert alert-primary" role="alert" v-show="state.loading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            アンケートを準備しています・・
        </div>
        <div class="alert alert-danger" role="alert" v-show="state.error && state.error.message">
            {{ state.error.message}}
        </div>
    </div>
</template>

<script>

export default {
    name: 'App',
    computed: {
        state: function(){
            return this.$store.state
        },
    }
}
</script>
